import ReactPlayer from 'react-player';
import { Invert } from '../Utils/Invert';
export function Video({ size, data }: any) {
    return <Invert data={data} size={size}>
        <ReactPlayer width='100%' controls url={data.props.video} />
    </Invert>
}
